export default "__VITE_ASSET__B9aCp7_y__"